import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import {
  Form,
  Select,
  Space,
  DatePicker,
  Avatar,
  Badge,
  Checkbox,
  Row,
  Col,
  Input,
  Radio,
  Modal,
  Spin,
  message,
} from "antd";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { CALL_API } from "../../../Common/api";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { shipmentType, TripTypeEnum } from "../../../Common/constant";
import Styled from "styled-components";
import filtericon from "../../../assets/images/filter-svgrepo-com (1).svg";
import ExportIcon from "../../../assets/images/export-svgrepo-com (1).svg";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
import StyledTable from "../../../Reusablecomponents/UITable/UITable";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Pie,
  Cell,
  PieChart,
} from "recharts";
import UIModal from "../../../Reusablecomponents/UIModal";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import moment from "moment";
dayjs.extend(utc);
dayjs.extend(timezone);

const Styledashboard = Styled.div`
.Custom {
  display: flex;
  align-items: center;
      justify-content: flex-end; /* Pushes content to the right */
  margin-bottom: 20px;
  gap: 20px;
}
    .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
     .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    
  }
    .timing-center {
    // margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    }
  .head {
  margin-bottom: 5px;
  color: #5f6d8c;
  height: 29px;
    // width: 84px;
  }
  .header-container {
  display: flex;
  justify-content: space-between; 
  align-items: center; 
  width: 100%;
}
  .consignment-value{
  color: #1F243B;
  font-size: 24px;
  font-weight: 600;
  }
  .total-mins{
  color: #363636;
    font-size: 20px;
  font-weight: 600;
  }

  .legend-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    align-items: center;
  }

  .legend-item {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 13px;
  }

  .legend-color {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    margin-right: 6px;
    flex-shrink: 0;
  }

  .legend-label {
    color: #333;
  }
  `;
const Consignmentreport = ({ activekey }) => {
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState([null, null]);
  const { Option } = Select;
  const [filterCount, setFilterCount] = useState(0);
  const [form] = Form.useForm();
  const [tripConsignmentData, setTripConsignmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [consignTotal, setConsignTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const [isconfigModalVisible, setIsconfigModalVisible] = useState(false);
  const [customDataLoaded, setCustomDataLoaded] = useState(false);
  const [AllCustomeData, SetAllCustomeData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const csvLinkEl = useRef();
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("AITRPT", "EX"),
    [reduxPermissions],
  );
  const vehicleOptions = vehicleList.map((item) => ({
    value: item.FVehicleName,
    label: item.FVehicleName,
  }));
  const deviceOptions = deviceList.map((item) => ({
    value: item.FGUID,
    label: item.FAssetID,
  }));

  const [filterValues1, setFilterValues1] = useState({});
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const fenceList = useSelector((state) => state?.authTracking?.fenceList);

  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const fetchAllDevice = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllDevice");
      setDeviceList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const fetchAllVehicle = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllVehicle");
      if (data?.companies && data?.companies.length > 0) {
        if (userInfo?.MCID !== 59) {
          const filteredVehicles = data.companies.filter(
            (vehicle) => vehicle.FAgentGUID === userInfo?.ECTSCompId,
          );
          setVehicleList(filteredVehicles);
        } else {
          setVehicleList(data.companies);
        }
      } else {
        setVehicleList([]);
      }
    } catch (error) {
      console.error("[fetchAllVehicle] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllDevice();
    fetchAllVehicle();
  }, []);

  const getTripConsignmentData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `aiReport/trip/get_consignment_report?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=${currentPage}&PageSize=${pageSize}`,
        {
          Vehid: filterValues1?.vehicleno || "",
          Cust: filterValues1?.consignor || 0,
          Shipper: filterValues1?.transporter || 0,
          FID: filterValues1?.fence || "",
          Triptype: filterValues1?.triptype || 0,
          Driver: filterValues1?.driver || 0,
          Tripcode: filterValues1?.tripcode || 0,
          code: filterValues1?.consigncode || 0,
          shipment: filterValues1?.shipment || 0,
          ReferenceNo: filterValues1?.ReferenceNo || "",
          ContainerNo: filterValues1?.ContainerNo || "",
        },
      );
      const newData1 = data?.ConsignmentReportTable?.map((entityItem) => {
        const enrichedItem = { ...entityItem };

        // Attach custom field values by matching REFID to ConsignId
        const matchedFields =
          (Array.isArray(AllCustomeData) ? AllCustomeData : []).filter(
            (field) => Number(field.REFID) === Number(entityItem.CONSIGNID),
          ) || [];

        matchedFields.forEach((field) => {
          enrichedItem[field.CFID] = field.VALUE;
        });

        return enrichedItem;
      });
      setTripConsignmentData(data);
      setTableData(newData1);
      setConsignTotal(data?.ConsignmentReportTable?.[0]?.TotalCount);
      setLoading(false);
    } catch (error) {
      console.error("[getAssignedConsignments] error -->", error);
    }
  };
  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getTripConsignmentData();
    }
  }, [filterValues1, selectedDate, currentPage, pageSize]);

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getTripConsignmentData();
    }
  }, [activekey]);

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  const prepareCSV1 = async (event, done) => {
    try {
      setCSVLoader(true);

      const { data } = await CALL_API(
        "POST",
        `aiReport/trip/get_consignment_report?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format("YYYY-MM-DD")}
        &PageNumber=1&PageSize=${consignTotal}`,
        {
          Vehid: filterValues1?.vehicleno || "",
          Cust: filterValues1?.consignor || 0,
          Shipper: filterValues1?.transporter || 0,
          FID: filterValues1?.fence || "",
          Triptype: filterValues1?.triptype || 0,
          Driver: filterValues1?.driver || 0,
          Tripcode: filterValues1?.tripcode || 0,
          code: filterValues1?.consigncode || 0,
          ShipmentType: filterValues1?.shipment || 1,
          ReferenceNo: filterValues1?.ReferenceNo || "",
          ContainerNo: filterValues1?.ContainerNo || "",
        },
      );

      const consignData = data?.ConsignmentReportTable;

      // Apply sorting to match table sort order
      const sortedData = applySorting(data?.ConsignmentReportTable);
      const customFieldMap = {};
      (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
        if (cf.CFID) {
          customFieldMap[cf.CFID] = cf.FIELDNAME || cf.FIELDCODE;
        }
      });
      const enrichedData = consignData.map((item) => {
        const matchedFields =
          (Array.isArray(AllCustomeData) ? AllCustomeData : []).filter(
            (f) => f.REFID === item.CONSIGNID,
          ) || [];

        const customFieldValues = {};

        // Ensure every custom field exists
        (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
          const fieldName = customFieldMap[cf.CFID] || `Custom_${cf.CFID}`;

          const matched = matchedFields.find((f) => f.CFID === cf.CFID);

          customFieldValues[fieldName] = matched?.VALUE || "-";
        });
        return {
          "Consign Code": item.code || "-",
          "Pickup Date & Time":
            formatttedtimevaluetwo(item.pickupdatetime) || "-",
          Consignor: item.custname || "-",
          Consignee: item.FNAME || "-",
          Vehicle: item.VehRegNo || "-",
          "Carbon Footprint (KgCo2)": item.CarbonFootprint || "-",
          "Driver Name": item.drivername || "-",
          "Trip Type": item.triptype
            ? item.triptype === 1
              ? "Local"
              : userInfo?.MCID === 72
                ? "Transit"
                : "Safari"
            : "-",
          "Reference No": item?.ReferenceNo || "-",
          "Container No": item?.ContainerNo || "-",
          "Loading Cycle": formatMinutes(item.LOADINGCYCLE?.toFixed(2)) || "-",
          "Offloading Cycle": formatMinutes(item?.OFFLOADINGCYCLE) || "-",
          "ODO (KMS)": item.gpsKMS || "-",
          Started: item?.Events?.Started
            ? formatttedtimevaluetwo(item?.Events?.Started)
            : "-",
          "Arrive at pick-up point": item?.Events?.Arrived_at_pickup_point
            ? formatttedtimevaluetwo(item?.Events?.Arrived_at_pickup_point)
            : "-",
          "Pickup Journey Started": item?.Events?.Pick_up_journey_started
            ? formatttedtimevaluetwo(item?.Events?.Pick_up_journey_started)
            : "-",
          "Delivery Journey Started": item?.Events?.Delivery_journey_started
            ? formatttedtimevaluetwo(item?.Events?.Delivery_journey_started)
            : "-",
          "Reached Delivery Point": item?.Events?.Reached_delivery_point
            ? formatttedtimevaluetwo(item?.Events?.Reached_delivery_point)
            : "-",
          "Return Journey Started": item?.Events?.Return_journey_started
            ? formatttedtimevaluetwo(item?.Events?.Return_journey_started)
            : "-",
          "Returned to Base": item?.Events?.Returned_to_base
            ? formatttedtimevaluetwo(item?.Events?.Returned_to_base)
            : "-",
          Finished: item?.Events?.Finished
            ? formatttedtimevaluetwo(item?.Events?.Finished)
            : "-",
          ...(userInfo?.MCID === 78 && {
            "Created By": item?.CreatedBy || "-",
            "Route Name": item?.RouteName || "-",
          }),
          ...customFieldValues,
        };
      });
      // Export if data exists
      if (enrichedData.length > 0) {
        setCSVList(enrichedData);
        setTimeout(() => csvLinkEl.current.link.click(), 500);
      } else {
        message.error("No data available to download.");
      }

      setCSVLoader(false);
    } catch (error) {
      setCSVLoader(false);
      console.error("[prepareCSV] error -->", error);
    }
  };

  const { RangePicker } = DatePicker;
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  const handlechange = (value) => {
    setDuration(value);
  };
  const handlechangefordate = (date, dateString) => {
    setSelectedDate(date);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  //Consignment Charts

  const chartData = tripConsignmentData?.ConsignmentStatusChart ?? [];
  const statusData = chartData.find((item) => item.Type === "Total") ?? {};
  const assigned = Number(statusData.Assigned) || 0;
  const inprogress = Number(statusData.Inprogress) || 0;
  const completed = Number(statusData.Completed) || 0;

  const totalConsignments = assigned + inprogress + completed;
  const values1 = [
    {
      label: "Unassigned",
      value: parseInt(statusData.Unassigned ?? 0), // Only if API provides it
      color: "#FF5555",
    },
    {
      label: "Assigned",
      value: parseInt(statusData.Assigned ?? 0),
      color: "rgb(108,167,255)",
    },
    {
      label: "In Progress",
      value: parseInt(statusData.Inprogress ?? 0), // match API casing exactly
      color: "#FFBC41",
    },
    {
      label: "Completed",
      value: parseInt(statusData.Completed ?? 0),
      color: "#69FF78",
    },
  ];

  //consignemnent status  customized Label
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    outerRadius,
    percent,
    index,
  }) => {
    const RADIAN = Math.PI / 180;
    const entry = values1[index];
    if (!entry) return null;

    const startX = cx + outerRadius * Math.cos(-midAngle * RADIAN);
    const startY = cy + outerRadius * Math.sin(-midAngle * RADIAN);
    const breakX = cx + (outerRadius + 20) * Math.cos(-midAngle * RADIAN);
    const breakY = cy + (outerRadius + 20) * Math.sin(-midAngle * RADIAN);

    const isLeft = midAngle > 90 && midAngle < 270;
    const endX = breakX + (isLeft ? -60 : 60);
    const verticalSpacing = 18; // space between labels
    const endY = breakY - index * verticalSpacing;
    const textAnchor = isLeft ? "end" : "start";

    return (
      <g>
        <polyline
          points={`${startX},${startY} ${breakX},${breakY} ${endX},${endY}`}
          stroke="#BEBEBE"
          strokeWidth={1}
          fill="none"
        />
        <rect
          x={endX - (isLeft ? 14 : 0)}
          y={endY - 7}
          width={14}
          height={14}
          rx={2}
          ry={2}
          fill={entry.color}
        />
        <text
          x={endX + (isLeft ? -25 : 25)}
          y={endY + 5}
          textAnchor={textAnchor}
          fill="#5F6D8C"
          fontSize={14}
        >
          {`${entry.label}   ${entry.value} (${(percent * 100).toFixed(0)}%)`}
        </text>
      </g>
    );
  };

  const COLORS = [
    "#73BEFF",
    "#FFFA75",
    "#AFCF66",
    "#D6FF75",
    "#9AFF75",
    "#75FFA3",
    "#75F4FF",
    "#05E7DC",
    "#52B4DA",
    "#FF75D3",
  ];

  // Calculate total loading cycle for percentage basis
  const totalLoadingCycle = tripConsignmentData?.ConsignmentLoadingTime?.reduce(
    (acc, item) => acc + (item.LoadingCycle ?? 0),
    0,
  );
  const formatMinutesToHHMM = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = Math.round(minutes % 60);
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const loadingTimeData =
    tripConsignmentData?.ConsignmentLoadingTime?.filter(
      (item) => (item.LoadingCycle ?? 0) > 0,
    ) // only positive
      .map((item, index) => {
        const cycle = item.LoadingCycle ?? 0;
        const percent =
          totalLoadingCycle > 0
            ? ((cycle / totalLoadingCycle) * 100).toFixed(2)
            : "0.00";

        const consignorName = item.CUSTNAME ?? "";

        return {
          name: consignorName,
          value: cycle,
          time: formatMinutesToHHMM(cycle),
          percent,
          color: COLORS[index % COLORS.length],
        };
      }) ?? [];

  const SMALL_THRESHOLD = 15; // ✅ tune this number to your needs

  const LoadingCycleTimeChart = ({ loadingTimeData }) => {
     const hasLessThanOnePercent = loadingTimeData.some(
      (item) => (item.percent < 1),
    );

    const useTooltipChart =
      loadingTimeData.length > SMALL_THRESHOLD || hasLessThanOnePercent;
    return !useTooltipChart 
      ? <InlineLabelChart data={loadingTimeData} />
      : <TooltipChart data={loadingTimeData} />;
  };

  const InlineLabelChart = ({ data }) => {
    const renderCustomLabel = ({ cx, cy, midAngle, outerRadius, payload, index }) => {
      if (!payload || payload.value === 0) return null;
      const RADIAN = Math.PI / 180;
      const radius = outerRadius + 25;
      const isLeft = midAngle > 90 && midAngle < 270;
      const bx = cx + radius * Math.cos(-midAngle * RADIAN);
      const by = cy + radius * Math.sin(-midAngle * RADIAN);
      const ex = bx + (isLeft ? -70 : 70);
      const clampedEx = isLeft ? Math.max(10, ex) : Math.min(cx * 2 - 10, ex);

      return (
        <g>
          <polyline points={`${cx + outerRadius * Math.cos(-midAngle * RADIAN)},${cy + outerRadius * Math.sin(-midAngle * RADIAN)} ${bx},${by} ${clampedEx},${by}`}
            stroke="#BEBEBE" fill="none" strokeWidth={1.5} />
          <circle cx={clampedEx} cy={by} r={7} fill={payload.color} />
          <text x={clampedEx + (isLeft ? -12 : 12)} y={by + 4}
            textAnchor={isLeft ? "end" : "start"}
            fill="#5F6D8C" fontSize={11} fontWeight={500}>
            {`${payload.name} ${payload.time} (${payload.percent}%)`}
          </text>
        </g>
      );
    };

    return (
      <div style={{ height: 380, overflow: 'visible' }}>
        <style>{`.recharts-wrapper svg, .recharts-surface { overflow: visible !important; }`}</style>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart margin={{ top: 80, right: 160, bottom: 80, left: 160 }}>
            <Pie data={data} cx="50%" cy="50%"
              innerRadius={70} outerRadius={100}
              dataKey="value" labelLine={false}
              label={renderCustomLabel}
              minAngle={2} paddingAngle={1}
              isAnimationActive={false}>
              {data.map((entry, i) => <Cell key={i} fill={entry.color} />)}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  };

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const d = payload[0].payload;
    return (
      <div style={{
        background: '#fff', border: '0.5px solid #ddd',
        borderRadius: 10, padding: '10px 14px', fontSize: 12,
        boxShadow: 'none', minWidth: 160
      }}>
        <p style={{ fontWeight: 500, marginBottom: 6, fontSize: 13 }}>{d.name}</p>
        <p style={{ color: '#888', display: 'flex', justifyContent: 'space-between', gap: 16 }}>
          Time <strong style={{ color: '#222' }}>{d.time}</strong>
        </p>
        <p style={{ color: '#888', display: 'flex', justifyContent: 'space-between', gap: 16 }}>
          Percentage <strong style={{ color: '#222' }}>{d.percent}%</strong>
        </p>
      </div>
    );
  };

  const TooltipChart = ({ data }) => (
    <>
    <div style={{ height: 280 }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={data} cx="50%" cy="50%"
            innerRadius={70} outerRadius={100}
            dataKey="value" label={false} labelLine={false}
            minAngle={1} paddingAngle={1}>
            {data.map((entry, i) => <Cell key={i} fill={entry.color} />)}
          </Pie>
          <Tooltip content={<CustomTooltip />} /> {/* ✅ all info on hover */}
        </PieChart>
      </ResponsiveContainer>
    </div>
    <div className="legend-container mx-2 mx-md-5 my-2">
    {data.map((item, index) => (
      <div key={index} className="legend-item">
        <span
          className="legend-color"
          style={{ backgroundColor: item.color }}
        />
        <span className="legend-label">
          {item.name} <strong>{item.percent}%</strong>
        </span>
      </div>
    ))}
  </div>
    </>
  );

  const formatMinutes = (value) => {
    if (value == null || isNaN(value)) return "-";
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };
  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(value).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };
  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle numeric fields
      if (
        ["LOADINGCYCLE", "OFFLOADINGCYCLE", "triptype"].includes(
          tableSort.field,
        )
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };
  const [customFields, setCustomFields] = useState([]);

  const customFieldOptions = Array.isArray(customFields)
    ? customFields.map((field) => ({
        label: field.FIELDNAME,
        value: field.CFID,
        disabled: false,
      }))
    : [];
  const [selectedCustomColumns, setSelectedCustomColumns] = useState([]);
  const GetAllCustomeData = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=${reftab}`,
      );

      SetAllCustomeData(data);
      setCustomDataLoaded(true);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };
  const loadCustomFields = async (reftab) => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: reftab,
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };
  const renderEventDate = (date) => {
    if (!date) return "-";

    const dt = dayjs.utc(date).tz("Africa/Nairobi");
    return `${dt.format("DD/MM/YYYY")} ${dt.format("hh:mm A")}`;
  };
  const columns1 = [
    {
      title: "Consign Code",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => (a.code || "").localeCompare(b.code || ""),
      sortOrder: tableSort.field === "code" ? tableSort.order : null,
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Pick Up Date and Time",
      dataIndex: "pickupdatetime",
      key: "pickupdatetime",
      sorter: (a, b) =>
        (a.pickupdatetime || "").localeCompare(b.pickupdatetime || ""),
      sortOrder: tableSort.field === "pickupdatetime" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";
        const dt = dayjs.utc(value).tz("Africa/Nairobi");
        return `${dt.format("DD/MM/YYYY")} ${dt.format("hh:mm A")}`;
      },
    },
    {
      title: "Consignor",
      dataIndex: "custname",
      key: "custname",
      sorter: (a, b) => (a.custname || "").localeCompare(b.custname || ""),
      sortOrder: tableSort.field === "custname" ? tableSort.order : null,
    },
    {
      title: "Vehicle",
      dataIndex: "VehRegNo",
      key: "VehRegNo",
      sorter: (a, b) => (a.VehRegNo || "").localeCompare(b.VehRegNo || ""),
      sortOrder: tableSort.field === "VehRegNo" ? tableSort.order : null,
    },
    {
      title: "Driver's Name",
      dataIndex: "drivername",
      key: "drivername",
      sorter: (a, b) => (a.drivername || "").localeCompare(b.drivername || ""),
      sortOrder: tableSort.field === "drivername" ? tableSort.order : null,
    },
    {
      title: "Trip Type",
      dataIndex: "triptype",
      key: "triptype",
      sorter: (a, b) => (a.triptype || 0) - (b.triptype || 0),
      sortOrder: tableSort.field === "triptype" ? tableSort.order : null,
      render: (type) =>
        type === 1 ? "Local" : userInfo?.MCID === 72 ? "Transit" : "Safari",
    },
    {
      title: "Container No",
      dataIndex: "ContainerNo",
      key: "ContainerNo",
      sorter: (a, b) =>
        (a.ContainerNo || "").localeCompare(b.ContainerNo || ""),
      sortOrder: tableSort.field === "ContainerNo" ? tableSort.order : null,
    },
    {
      title: "Started",
      dataIndex: ["Events", "Started"],
      key: "Started",
      sorter: (a, b) =>
        (a.Events?.Started || "").localeCompare(b.Events?.Started || ""),
      sortOrder: tableSort.field === "Started" ? tableSort.order : null,
      render: renderEventDate,
    },
    {
      title: "Arrive at pick-up point",
      dataIndex: ["Events", "Arrived_at_pickup_point"],
      key: "Arrived_at_pickup_point",
      sorter: (a, b) =>
        (a.Events?.Arrived_at_pickup_point || "").localeCompare(
          b.Events?.Arrived_at_pickup_point || "",
        ),
      sortOrder:
        tableSort.field === "Arrived_at_pickup_point" ? tableSort.order : null,
      render: renderEventDate,
    },
    {
      title: "Pickup Journey Started",
      dataIndex: ["Events", "Pickup_journey_started"],
      key: "Pickup_journey_started",
      sorter: (a, b) =>
        (a.Events?.Pickup_journey_started || "").localeCompare(
          b.Events?.Pickup_journey_started || "",
        ),
      sortOrder:
        tableSort.field === "Pickup_journey_started" ? tableSort.order : null,
      render: renderEventDate,
    },
    {
      title: "Delivery Journey Started",
      dataIndex: ["Events", "Delivery_journey_started"],
      key: "Delivery_journey_started",
      sorter: (a, b) =>
        (a.Events?.Delivery_journey_started || "").localeCompare(
          b.Events?.Delivery_journey_started || "",
        ),
      sortOrder:
        tableSort.field === "Delivery_journey_started" ? tableSort.order : null,
      render: renderEventDate,
    },
    {
      title: "Reached Delivery Point",
      dataIndex: ["Events", "Reached_delivery_point"],
      key: "Reached_delivery_point",
      sorter: (a, b) =>
        (a.Events?.Reached_delivery_point || "").localeCompare(
          b.Events?.Reached_delivery_point || "",
        ),
      sortOrder:
        tableSort.field === "Reached_delivery_point" ? tableSort.order : null,
      render: renderEventDate,
    },
    {
      title: "Return Journey Started",
      dataIndex: ["Events", "Return_journey_started"],
      key: "Return_journey_started",
      sorter: (a, b) =>
        (a.Events?.Return_journey_started || "").localeCompare(
          b.Events?.Return_journey_started || "",
        ),
      sortOrder:
        tableSort.field === "Return_journey_started" ? tableSort.order : null,
      render: renderEventDate,
    },
    {
      title: "Returned to Base",
      dataIndex: ["Events", "Returned_to_base"],
      key: "Returned_to_base",
      sorter: (a, b) =>
        (a.Events?.Returned_to_base || "").localeCompare(
          b.Events?.Returned_to_base || "",
        ),
      sortOrder:
        tableSort.field === "Returned_to_base" ? tableSort.order : null,
      render: renderEventDate,
    },
    {
      title: "Finished",
      dataIndex: ["Events", "Finished"],
      key: "Finished",
      sorter: (a, b) =>
        (a.Events?.Finished || "").localeCompare(b.Events?.Finished || ""),
      sortOrder: tableSort.field === "Finished" ? tableSort.order : null,
      render: renderEventDate,
    },
    ...(Number(userInfo?.MCID) === 78
      ? [
          {
            title: "Reference No",
            dataIndex: "ReferenceNo",
            key: "ReferenceNo",
            sorter: (a, b) =>
              (a.ReferenceNo || "").localeCompare(b.ReferenceNo || ""),
            sortOrder:
              tableSort.field === "ReferenceNo" ? tableSort.order : null,
          },
          {
            title: "Loading Cycle",
            dataIndex: "LOADINGCYCLE",
            key: "LOADINGCYCLE",
            sorter: (a, b) => (a.LOADINGCYCLE || 0) - (b.LOADINGCYCLE || 0),
            sortOrder:
              tableSort.field === "LOADINGCYCLE" ? tableSort.order : null,
            render: (value) => formatMinutes(value),
          },
          {
            title: "Offloading Cycle",
            dataIndex: "OFFLOADINGCYCLE",
            key: "OFFLOADINGCYCLE",
            sorter: (a, b) =>
              (a.OFFLOADINGCYCLE || 0) - (b.OFFLOADINGCYCLE || 0),
            sortOrder:
              tableSort.field === "OFFLOADINGCYCLE" ? tableSort.order : null,
            render: (value) => formatMinutes(value),
          },
           {
            title: "Created By",
            dataIndex: "CreatedBy",
            key: "CreatedBy",
            sorter: (a, b) => (a.CreatedBy || "").localeCompare(b.CreatedBy || ""),
            sortOrder: tableSort.field === "CreatedBy" ? tableSort.order : null,
            render: (value) => value ?? "-",
          },
          {
            title: "Route name",
            dataIndex: "RouteName",
            key: "RouteName",
            sorter: (a, b) => (a.RouteName || "").localeCompare(b.RouteName || ""),
            sortOrder: tableSort.field === "RouteName" ? tableSort.order : null,
            render: (value) => value ?? "-",
          }
        ]
      : []),
  ];
  const combinedColumns = useMemo(() => {
    const staticCols = [...columns1];

    // Only show custom fields that are selected
    const dynamicCols = customFields
      .filter((field) => selectedCustomColumns.includes(field.CFID))
      .map((field) => ({
        title: field.FIELDNAME,
        dataIndex: field.CFID,
        key: field.CFID,
        sorter: false,
        render: (_, record) => record?.[field.CFID] ?? "-",
      }));

    return [...staticCols, ...dynamicCols];
  }, [columns1, customFields, selectedCustomColumns]);
  const columnsForInterscope = [...combinedColumns, columns1];
  const columnsLogic = userInfo?.MCID === 78 ? columnsForInterscope : columns1;
  const formatttedtimevaluetwo = (value) => {
    const dt = dayjs.utc(value).tz("Africa/Nairobi");
    return `${dt.format("DD/MM/YYYY")} ${dt.format("hh:mm A")}`;
  };
  let newvalue = formatttedtimevaluetwo();
  useEffect(() => {
    if (customFields.length && selectedCustomColumns.length === 0) {
      setSelectedCustomColumns(customFields.map((f) => f.CFID));
    }
  }, [customFields]);
  useEffect(() => {
    const fetchAllCustomFields = async () => {
      setLoading(true);
      try {
        const [dataAIBulkcreate] = await Promise.all([
          CALL_API("POST", `mastertable/GetByReftab`, {
            ReftableId: "AIBulkcreate",
            RefId: 0,
            Active: 1,
            McId: userInfo?.MCID,
          }),
        ]);
        // Merge and deduplicate by CFID
        const allFields = [
          // ...(Array.isArray(dataAICONSIGN?.data) ? dataAICONSIGN.data : []),
          ...(Array.isArray(dataAIBulkcreate?.data)
            ? dataAIBulkcreate.data
            : []),
        ];
        // Only set empty if both are truly empty
        if (allFields.length === 0) {
          setCustomFields([]);
        } else {
          const uniqueFields = Object.values(
            allFields.reduce((acc, field) => {
              acc[field.CFID] = field;
              return acc;
            }, {}),
          );
          setCustomFields(uniqueFields);
        }
      } catch (error) {
        // Only clear if both failed
        setCustomFields([]);
        console.error("Error fetching custom fields:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllCustomFields();
    // GetAllCustomeData("AICONSIGN");
    GetAllCustomeData("AIBulkcreate");
    loadCustomFields("AIBulkcreate");
  }, []);
  useEffect(() => {
    if (
      customDataLoaded &&
      Array.isArray(customFields) &&
      customFields.length > 0 &&
      Array.isArray(selectedCustomColumns) &&
      selectedCustomColumns.length > 0
    ) {
      getTripConsignmentData();
    }
  }, [customDataLoaded, customFields, selectedCustomColumns]);

  return (
    <Styledashboard>
      <div>
        <div
          className="total"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center", // Align items vertically
            width: "100%",
          }}
        >
          {/* Overview on the left */}
          <div className="head" style={{ flex: 1 }}>
            Chart View
          </div>

          {/* Duration and Date Range on the right */}
          <div className="Custom" style={{ display: "flex", gap: "20px" }}>
            <div className="dropstyle">
              <Form.Item
                label=""
                name="dropdown"
                rules={[
                  { required: true, message: "Please select an option!" },
                ]}
              >
                <Select
                  placeholder="Custom Range"
                  onChange={handlechange}
                  defaultValue={duration}
                  className="plc"
                >
                  {Duration.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="dropstyle1">
              <Space direction="vertical" size={12}>
                <RangePicker
                  value={selectedDate}
                  onChange={handlechangefordate}
                />
              </Space>
            </div>
            <div>
              <Badge
                count={filterCount}
                className="badg"
                // onClick={() => setFilterModalOpen1(true)}
                onClick={showModal}
              >
                <Avatar
                  shape="circle"
                  size="medium"
                  src={filtericon}
                  className="filterstyle"
                />
              </Badge>
            </div>
          </div>
        </div>
        {/* <Modal
          open={filterModalOpen1}
          onCancel={() => setFilterModalOpen1(false)}
          width={900}
          footer={
            <ButtonFilled
              onClick={() => {
                setFilterValues1({ userid: "", username: "", email: "" }); // Reset the state
                filterform?.setFieldsValue({
                  userid: "",
                  username: "",
                  email: "",
                });
                setFilterCount1(0);
                setFilterModalOpen1(false);
              }}
            >
              {" "}
              Clear All{" "}
            </ButtonFilled>
          }
        >
          <Row>
            <Col xl={24} xs={{ span: 24, order: 2 }}>
              <div className="container_for_kpi_filter">
                <h6 className="Filter_for_clickablerow">
                  Filter ({filterCount1})
                </h6>
              
              </div>
            </Col>
          </Row>

          <Form
            form={filterform1}
            layout="vertical"
            onValuesChange={(value, allvalues) => {
              const count = Object.values(allvalues).filter(
                (val) =>
                  val !== undefined &&
                  (val !== null) & 1 & (String(val).trim() !== "")
              ).length;

              setFilterCount1(count);
              setFilterValues1(allvalues);
            }}
            initialValues={filterValues1}
          >
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Vehicle No." name="vehicleno">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={vehicleOptions}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />{" "}
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consignor" name="consignor">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consignerList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />{" "}
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Transporter" name="transporter">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={transporterList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />{" "}
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Shipment Type" name="shipment">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={shipmentType?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />{" "}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consignee" name="consignee">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consigneeList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />{" "}
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consign Code" name="consigncode">
                  <Input placeholder="" className="rounded-pill" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Trip" name="trip">
                  <Input placeholder="" className="rounded-pill" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Trip Type" name="triptype">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={TripTypeEnum?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />{" "}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal> */}

        <Modal
          open={isModalOpen}
          onCancel={handleCancel}
          width={900}
          footer={
            <ButtonFilled
              onClick={() => {
                form.resetFields();
                setFilterValues1({});
              }}
            >
              {" "}
              Clear All{" "}
            </ButtonFilled>
          }
        >
          <Row>
            <Col xl={24} xs={{ span: 24, order: 2 }}>
              <div className="container_for_kpi_filter">
                <h6 className="Filter_for_clickablerow">
                  Filter ({filterCount})
                </h6>
                {/* <p className="Filter_for_Result">4 Result Found </p> */}
              </div>
            </Col>
          </Row>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(value, allvalues) => {
              getFilterCount();
              setFilterValues1(allvalues);
            }}
          >
            <Row gutter={16}>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Vehicle No" name="vehicleno">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={vehicleOptions}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consignor" name="consignor">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consignerList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Transporter" name="transporter">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={transporterList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consignee" name="fence">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={fenceList?.map((item) => ({
                      label: item.FName,
                      value: item.FGUID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Consign Code" name="consigncode">
                  <Input placeholder="" className="rounded-pill" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Trip Code" name="trip">
                  <Input placeholder="" className="rounded-pill" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Trip Type" name="triptype">
                  <Select
                    className="w-100"
                    showSearch
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  >
                    <Option value={2}>
                      {userInfo?.MCID === 72 ? "Transit" : "Safari"}
                    </Option>
                    <Option value={1}>Local</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Shipment Type" name="shipment">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={shipmentType?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                    // suffixIcon={<SearchOutlined className="search_icon" />}
                  />{" "}
                </Form.Item>
              </Col>
              {userInfo?.MCID === 78 && (
                <>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item label="Container No" name="ContainerNo">
                      <Input placeholder="" className="rounded-pill" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={24} md={6}>
                    <Form.Item label="Reference No" name="ReferenceNo">
                      <Input placeholder="" className="rounded-pill" />
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>
          </Form>
        </Modal>
        <UIModal
          width={600}
          height={600}
          open={isconfigModalVisible}
          onClose={() => {
            setIsconfigModalVisible(false);
          }}
          closeButton={false}
          size="md"
          header={
            <div className="text-start">
              <h2>Customized Column</h2>
              <label
                style={{ marginBottom: 8, display: "block", color: "#5F6D8C" }}
              >
                Columns
              </label>
            </div>
          }
          footer={
            <div className="mt-2 w-100 d-flex justify-content-end">
              <ButtonFilled
                onClick={() => {
                  setIsconfigModalVisible(false); // Close the modal
                }}
              >
                Save
              </ButtonFilled>
              <Buttontransparent
                onClick={() => {
                  setIsconfigModalVisible(false); // Just close the modal
                }}
              >
                Cancel
              </Buttontransparent>
            </div>
          }
        >
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Select custom columns"
            value={selectedCustomColumns}
            onChange={setSelectedCustomColumns}
            dropdownStyle={{ maxHeight: 250, overflow: "auto" }}
            dropdownRender={(menu) => (
              <div>
                <Checkbox.Group
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "8px 12px",
                  }}
                  value={selectedCustomColumns}
                  onChange={setSelectedCustomColumns}
                >
                  {customFieldOptions.map((option) => (
                    <Checkbox
                      key={option.value}
                      value={option.value}
                      disabled={option.disabled}
                    >
                      {option.label}
                    </Checkbox>
                  ))}
                </Checkbox.Group>
              </div>
            )}
          >
            {customFieldOptions.map((option) => (
              <Select.Option
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </UIModal>
        <Spin spinning={loading}>
          <div id="Export Chart">
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "400px",
                border: "#E7E7ED 1px solid",
                borderRadius: "8px",
              }}
            >
              {/* Title and Export Icon Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <p
                  className="pb-0 mb-0"
                  style={{ fontWeight: 500, fontSize: "16px", margin: 0 }}
                >
                  Consignment Status
                </p>
                <img
                  src={ExportIcon}
                  alt="Export"
                  style={{ cursor: exportAllowed ? "pointer" : "not-allowed" }}
                  onClick={() => {
                    if (!exportAllowed) return;
                    handleDownloadChart("Export Chart", "Consignment Status");
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {/* Pie Chart */}
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={values1}
                      startAngle={180}
                      endAngle={0}
                      innerRadius={100}
                      outerRadius={160}
                      dataKey="value"
                      cx="50%"
                      cy="65%"
                      labelLine={false}
                      label={renderCustomizedLabel}
                    >
                      {values1.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </div>

              {/* Centered Total Consignments */}
              <div
                style={{
                  position: "absolute",
                  top: "75%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  textAlign: "center",
                  pointerEvents: "none",
                }}
              >
                <div className="text-gray-400 text-sm">Total Consignments</div>
                <div className="consignment-value">{totalConsignments}</div>
              </div>
            </div>
          </div>
        </Spin>
        <br />
        <Spin spinning={loading}>
          <div id="Export Chart2">
            <div
              style={{
                position: "relative",
                width: "100%",
                // height: "400px",
                border: "#E7E7ED 1px solid",
                borderRadius: "8px",
              }}
            >
              {/* Title and Export Icon Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "20px",
                }}
              >
                <p
                  className="pb-0 mb-0"
                  style={{ fontWeight: 500, fontSize: "16px", margin: 0 }}
                >
                  Loading Cycle Time
                </p>
                <img
                  src={ExportIcon}
                  alt="Export"
                  style={{ cursor: exportAllowed ? "pointer" : "not-allowed" }}
                  onClick={() => {
                    if (!exportAllowed) return;
                    handleDownloadChart("Export Chart2", "Loading Time");
                  }}
                />
              </div>
                {LoadingCycleTimeChart && <LoadingCycleTimeChart loadingTimeData={loadingTimeData} />}
            </div>
          </div>
        </Spin>
        <br />
        <br />
        <div className="header-container">
          <div className="head">
            {tripConsignmentData?.ConsignmentReportTable?.[0]?.TotalCount}{" "}
            records found.
          </div>
          <div>
            <Spin spinning={CSVLoader}>
              <img
                src={ExportIcon}
                alt="Upload Icon"
                style={{ cursor: exportAllowed ? "pointer" : "not-allowed" }}
                className="hover-image"
                onClick={() => {
                  if (!exportAllowed) return;
                  prepareCSV1();
                }}
              />
            </Spin>
            <CSVLink
              data={CSVList}
              filename={"Consignment_Reports.csv"}
              asyncOnClick={true}
              ref={csvLinkEl}
            />
          </div>
        </div>
        <br />
        <div>
          <StyledTable
            dataSource={tableData}
            columns={columnsLogic}
            pagination={false}
            onChange={(pagination, filters, sorter) => {
              setTableSort({
                field: sorter.field,
                order: sorter.order,
              });
            }}
          />
        </div>
      </div>

      <ReusablePagination
        pageSize={pageSize}
        handlePageSizeChange={handlePageSizeChange}
        currentPage={currentPage}
        total={consignTotal}
        handlePageChange={handlePageChange}
      />
    </Styledashboard>
  );
};

export default Consignmentreport;